export default __webpack_public_path__ + "static/eco-declaration-11f644e7251030bdbd2de788ca386dd3.png";